import {Component, OnInit, ViewChild} from '@angular/core';
import {NetworkService} from "./network.service";
import {Company} from "../model/company.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {UtilService} from "../shared/util.service";

@Component({
    selector: 'app-networks',
    templateUrl: './networks.component.html',
    styleUrls: ['./networks.component.scss'],
    standalone: false
})
export class NetworksComponent implements OnInit {

  companies = [];
  dataSource = new MatTableDataSource(this.companies);

  searchText = null;

  displayedColumns: string[] = [
    'id',
    'name',
    'actions'
  ];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
    private service: NetworkService,
    private util: UtilService,
  ) { }

  ngOnInit(): void {
    this.fetchCompanies();
    this.setDatatable();
  }

  fetchCompanies() {
    this.service.getItems().subscribe((resp:any) => {
      if (resp && resp.length) {
        this.companies = resp.map(r => new Company(r));
        this.dataSource.data = this.companies;
      }
    })
  }
  setDatatable() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.util.tableSorting;
  }

  applyFilter() {
    this.dataSource.filter = this.searchText.trim().toLowerCase();
  }
}
